export const CARD_DECK_INTERVAL_MS = 4_500;
export const cardDeckDepth = (count: number) => Math.min(2, Math.max(0, count - 1));
export const cardDeckFootprint = (count: number) => cardDeckDepth(count) ? 24 + (cardDeckDepth(count) - 1) * 12 : 0;
